import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/profile_cartoon.png'


const _withScopeId = n => (_pushScopeId("data-v-ce31137e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-12" }
const _hoisted_2 = { class: "col-span-7 col-start-1 flex flex-col" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-opacity-95 text-theme1 text-2xl" }, " I'm Bar, an aspiring game developer. ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-opacity-95 text-theme1 text-2xl" }, " A team player with great communication skills looking to thrive in a creative environment. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-opacity-95 text-theme1 text-2xl mt-3" }, " Currently working towards a degree in game design by Tiltan School of Design. ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-opacity-95 text-theme1 text-2xl mt-3" }, " Keen to learn new skills and motivated to create fun games. ", -1))
const _hoisted_7 = { class: "mt-6 text-2xl" }
const _hoisted_8 = ["href"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("RESUME")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "image my-auto col-start-9 col-span-3",
  src: _imports_0
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_BaseSection = _resolveComponent("BaseSection")!

  return (_openBlock(), _createBlock(_component_BaseSection, { title: "About Me" }, {
    "section-body": _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              class: "text-theme1 underline opacity-80",
              href: `${_ctx.publicPath}assets/static/CV_BarRonen.pdf`,
              download: "CV_BarRonen.pdf"
            }, [
              _createVNode(_component_font_awesome_icon, {
                class: "text-white mr-2",
                icon: ['fas', 'file-pdf']
              }),
              _hoisted_9
            ], 8, _hoisted_8)
          ])
        ]),
        _hoisted_10
      ])
    ]),
    _: 1
  }))
}